module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/software-library-1-49c7898393b51f867fbc654e1c38c29e.jpg";